export const SITE = {
  name: 'S+N Blech- und Metallverarbeitungs GmbH',
  shortName: 'S+N',
  logoUrl: 'https://www.sn-metall.de/mediapool/126/1269216/resources/logo_609_112985789.jpg',
  street: 'Beierfelder Str. 22',
  city: '08315 Lauter-Bernsbach',
  phone: '03774 - 662149',
  phoneHref: 'tel:+493774662149',
  email: 'info@sn-metall.de',
  emailHref: 'mailto:info@sn-metall.de',
  register: 'Amtsgericht Chemnitz HRB 19316',
  vat: 'DE 218655963',
  managingDirector: 'Axel Friedrich',
  founded: 2001,
};